import * as React from 'react';
import { observer } from 'mobx-react';
import { NotificationItem } from 'typings/notificationSummary';

export interface INotificationItemViewProps {
    item: NotificationItem;
}

@observer
export class NotificationItemView extends React.Component<INotificationItemViewProps> {
    constructor(props: INotificationItemViewProps) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    render(): React.ReactNode {
        const { item } = this.props;
        return (
            <button
                className="notification-item pointer"
                onClick={this.handleClick}
            >
                <div>
                    <i className={item.iconCss} />
                </div>
                <div className="notification-content">
                    <div>
                        <div className="pxl-header-xxsmall">{item.titleText}</div>
                        <div className="pxl-text-xs">{item.contentText}</div>
                    </div>
                    <span className="timestamp pxl-text-xs">{item.timeStampText}</span>
                </div>
            </button>
        );
    }

    private handleClick(): void {
        this.props.item.onClick();
    }
}

type INotificationItemViewType = typeof NotificationItemView;
export interface INotificationItemView extends INotificationItemViewType { }